export enum PDCAStatus {
  Plan = 0,
  Do = 1,
  Check = 2,
  Act = 3,
}
